<template>
  <div class="edit-form-modern">
    <!-- Delete Confirmation Modal -->
    <b-modal
      size="lg"
      hide-header-close
      no-close-on-backdrop
      hide-footer
      :id="`delete-client-${data.id}`"
      content-class="modern-modal"
    >
      <template #modal-header="{ close }">
        <div class="modal-header-danger">
          <h3 class="modal-title-modern">
            <i class="fas fa-exclamation-triangle mr-3"></i>
            Confirmar Exclusão
          </h3>
          <button type="button" class="close-btn-modern" @click="close()">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </template>

      <div class="delete-modal-content">
        <div class="warning-section">
          <div class="warning-icon">
            <i class="fas fa-trash-alt"></i>
          </div>
          <div class="warning-text">
            <h4>Excluir Cliente</h4>
            <p>Esta ação não pode ser desfeita. Verifique as opções abaixo:</p>
          </div>
        </div>

        <ReleasesDelete
          type="finance_client"
          :id="data.id"
          @total="handleVerifyReleasesToDelete"
        />

        <div v-if="totalReleases > 0" class="releases-warning">
          <div class="releases-info">
            <i class="fas fa-info-circle mr-2"></i>
            <span
              >Há <strong>{{ totalReleases }}</strong> lançamento(s)
              vinculado(s) a este cliente.</span
            >
          </div>

          <div class="options-section">
            <h5>O que deseja fazer com os lançamentos?</h5>

            <div class="radio-options">
              <div class="radio-option">
                <input
                  v-model="type_delete"
                  class="radio-input"
                  type="radio"
                  name="typeDelete"
                  id="type_only_delete"
                  value="type_only_delete"
                />
                <label class="radio-label" for="type_only_delete">
                  <span class="radio-indicator"></span>
                  <span class="radio-text">Deixar lançamentos sem cliente</span>
                </label>
              </div>

              <div class="radio-option">
                <input
                  v-model="type_delete"
                  class="radio-input"
                  type="radio"
                  name="typeDelete"
                  id="type_delete_transfer"
                  value="type_delete_transfer"
                />
                <label class="radio-label" for="type_delete_transfer">
                  <span class="radio-indicator"></span>
                  <span class="radio-text">Transferir para outro cliente</span>
                </label>
              </div>
            </div>

            <div
              v-if="type_delete == 'type_delete_transfer'"
              class="transfer-section"
            >
              <label class="form-label">Selecionar cliente de destino:</label>
              <select v-model="transfer_id" class="form-control-modern">
                <option :value="null">Selecione um cliente...</option>
                <option
                  v-for="(item, key) in finance_client"
                  :value="item.id"
                  :key="key"
                  v-show="item.id != data.id"
                >
                  {{ item.name }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <ErrorsMessages :errors="errorsDelete" />

        <div class="modal-actions">
          <v-btn
            @click="$bvModal.hide(`delete-client-${data.id}`)"
            class="cancel-btn"
          >
            <i class="fas fa-times mr-2"></i>
            Cancelar
          </v-btn>
          <v-btn
            :disabled="loading"
            @click="handleDelete"
            class="delete-btn"
            :loading="loadingDelete"
          >
            <i class="fas fa-trash mr-2"></i>
            {{ loadingDelete ? "Excluindo..." : "Confirmar Exclusão" }}
          </v-btn>
        </div>
      </div>
    </b-modal>

    <!-- Main Edit Form -->
    <div class="edit-container">
      <!-- Header Section -->
      <div class="form-header">
        <div class="header-content">
          <h3 class="form-title">
            <i class="fas fa-user-edit title-icon"></i>
            Editar Cliente
          </h3>
          <p class="form-subtitle">
            Atualize as informações do cliente selecionado
          </p>
        </div>
      </div>

      <!-- Tabs Navigation -->
      <div class="tabs-container">
        <nav class="modern-tabs">
          <button
            type="button"
            class="tab-button active"
            @click="errors = []"
            data-toggle="tab"
            data-target="#informacoes"
            aria-controls="informacoes"
          >
            <i class="fas fa-user tab-icon"></i>
            <span class="tab-text">Informações</span>
          </button>
        </nav>
      </div>

      <!-- Tab Content -->
      <div class="tab-content-modern">
        <div class="tab-pane-modern active" id="informacoes">
          <div class="form-section">
            <!-- Personal Information Section -->
            <div class="section-header">
              <h4 class="section-title">
                <i class="fas fa-id-card mr-2"></i>
                Dados Pessoais
              </h4>
            </div>

            <div class="form-grid">
              <div v-if="resident_id" class="form-group full-width">
                <label class="form-label">Residente Vinculado</label>
                <select
                  disabled
                  v-model="resident_id"
                  class="form-control-modern disabled"
                >
                  <option :value="null">Selecione...</option>
                  <option v-if="resident.length > 0" :value="resident[0].id">
                    {{ resident[0].name }}
                  </option>
                  <option
                    v-for="(resident, key) in residents"
                    :value="resident.id"
                    :key="key"
                  >
                    {{ resident.name }}
                  </option>
                </select>
              </div>

              <div class="form-group checkbox-group">
                <div class="custom-checkbox">
                  <input
                    class="checkbox-input"
                    type="checkbox"
                    v-model="is_foreign"
                    id="is_foreign"
                  />
                  <label class="checkbox-label" for="is_foreign">
                    <span class="checkbox-indicator"></span>
                    <span class="checkbox-text">Estrangeiro</span>
                  </label>
                </div>
              </div>

              <div class="form-group">
                <label class="form-label">CPF/CNPJ</label>
                <input
                  type="text"
                  v-model="cpf_cnpj"
                  class="form-control-modern"
                  placeholder="Digite o CPF ou CNPJ"
                />
              </div>

              <div class="form-group">
                <LabelRequiredField label="Nome/Razão Social" />
                <input
                  type="text"
                  class="form-control-modern"
                  v-model="name"
                  placeholder="Digite o nome completo"
                />
              </div>

              <div class="form-group">
                <label class="form-label">Nome Fantasia</label>
                <input
                  type="text"
                  class="form-control-modern"
                  v-model="fantasy_name"
                  placeholder="Digite o nome fantasia"
                />
              </div>

              <div class="form-group">
                <label class="form-label">Inscrição Estadual</label>
                <input
                  type="text"
                  class="form-control-modern"
                  v-model="ie"
                  placeholder="Digite a I.E."
                />
              </div>

              <div class="form-group">
                <label class="form-label">Inscrição Municipal</label>
                <input
                  type="text"
                  class="form-control-modern"
                  v-model="im"
                  placeholder="Digite a I.M."
                />
              </div>

              <div class="form-group">
                <label class="form-label">E-mail</label>
                <input
                  type="email"
                  class="form-control-modern"
                  v-model="email"
                  placeholder="exemplo@email.com"
                />
              </div>

              <div class="form-group">
                <label class="form-label">Telefone</label>
                <BInputPhone v-model="telephone" />
              </div>
            </div>

            <!-- Address Section -->
            <div class="section-header">
              <h4 class="section-title">
                <i class="fas fa-home mr-2"></i>
                Endereço
              </h4>
            </div>

            <div class="form-grid">
              <div class="form-group">
                <label class="form-label">CEP</label>
                <BInputCEP @retrieved="inputCEP" v-model="cep" />
              </div>

              <div class="form-group">
                <label class="form-label">Endereço</label>
                <input
                  type="text"
                  class="form-control-modern"
                  v-model="address"
                  placeholder="Rua, avenida, etc."
                />
              </div>

              <div class="form-group">
                <label class="form-label">Número</label>
                <input
                  type="text"
                  class="form-control-modern"
                  v-model="address_number"
                  placeholder="Nº"
                />
              </div>

              <div class="form-group">
                <label class="form-label">Complemento</label>
                <input
                  type="text"
                  class="form-control-modern"
                  v-model="complement"
                  placeholder="Apto, sala, etc."
                />
              </div>

              <div class="form-group">
                <label class="form-label">Bairro</label>
                <input
                  type="text"
                  class="form-control-modern"
                  v-model="neighborhood"
                  placeholder="Nome do bairro"
                />
              </div>

              <div class="form-group">
                <label class="form-label">Estado</label>
                <select v-model="uf_id" class="form-control-modern">
                  <option value="">Selecione o estado...</option>
                  <option
                    v-for="(item, key) in ufs"
                    :value="item.id"
                    :key="key"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>

              <div class="form-group">
                <label class="form-label">Cidade</label>
                <input
                  type="text"
                  class="form-control-modern"
                  v-model="city"
                  placeholder="Nome da cidade"
                />
              </div>

              <div v-show="is_foreign" class="form-group">
                <label class="form-label">País</label>
                <select v-model="country" class="form-control-modern">
                  <option value="">Selecione o país...</option>
                  <option
                    v-for="(item, key) in countries"
                    :value="item.name"
                    :key="key"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </div>

            <!-- Banking Section -->
            <div class="section-header">
              <h4 class="section-title">
                <i class="fas fa-university mr-2"></i>
                Dados Bancários
              </h4>
            </div>

            <div class="form-grid">
              <div class="form-group">
                <label class="form-label">Banco</label>
                <select v-model="bank_id" class="form-control-modern">
                  <option value="">Selecione o banco...</option>
                  <option
                    v-for="(item, key) in banks"
                    :value="item.id"
                    :key="key"
                  >
                    {{ item.code ? `${item.code} - ` : "" }} {{ item.name }}
                  </option>
                </select>
              </div>

              <div class="form-group">
                <label class="form-label">Agência</label>
                <input
                  type="text"
                  class="form-control-modern"
                  v-model="agency"
                  placeholder="Número da agência"
                />
              </div>

              <div class="form-group">
                <label class="form-label">Conta</label>
                <input
                  type="text"
                  class="form-control-modern"
                  v-model="account"
                  placeholder="Número da conta"
                />
              </div>

              <div class="form-group">
                <label class="form-label">Status</label>
                <select v-model="status" class="form-control-modern">
                  <option value="1">ATIVO</option>
                  <option value="0">INATIVO</option>
                </select>
                <small class="help-text">
                  Apenas clientes ativos poderão ser utilizados nos lançamentos
                </small>
              </div>

              <div class="form-group full-width">
                <label class="form-label">Observações</label>
                <ChromeSpeechToTextTextarea v-model="note" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Form Footer -->
      <div class="form-footer">
        <ErrorsMessages :errors="errors" />
        <WarningRequiredFields />

        <div class="actions-section">
          <v-btn
            v-if="!data.resident_id && permission('remove', 'financial_client')"
            :disabled="loadingDelete"
            class="delete-action-btn"
            @click="deleteClient"
          >
            <i class="fas fa-trash mr-2"></i>
            Excluir Cliente
          </v-btn>

          <v-btn
            :disabled="loading"
            @click="update"
            class="save-btn"
            :loading="loading"
          >
            <i class="fas fa-save mr-2"></i>
            {{ loading ? "Salvando..." : "Salvar Alterações" }}
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../Components/ErrorsMessages";
import WarningRequiredFields from "../../Components/WarningRequiredFields";
import LabelRequiredField from "../../Components/LabelRequiredField";
import BInputCEP from "../../Components/BInputCEP";
import BInputPhone from "../../Components/BInputPhone";
import ChromeSpeechToTextTextarea from "../../Components/ChromeSpeechToTextTextarea";
import ReleasesDelete from "../Configuration/Delete/releases.vue";
import api from "../../../services/api";
import toast from "../../../lib/ToastNotification";
import countries from "../../../lib/countries";
import permission from "../../../lib/permission";

export default {
  name: "Edit",

  components: {
    ErrorsMessages,
    WarningRequiredFields,
    BInputCEP,
    BInputPhone,
    ChromeSpeechToTextTextarea,
    LabelRequiredField,
    ReleasesDelete,
  },

  props: {
    residents: Array,
    all_residents: Array,
    data: Object,
    ufs: Array,
    banks: Array,
    finance_client: Array,
  },

  data() {
    return {
      totalReleases: 0,
      type_delete: null,
      countries: [],
      resident: [],
      transfer_id: null,
      resident_id: "",
      cpf_cnpj: "",
      is_foreign: false,
      name: "",
      fantasy_name: "",
      ie: "",
      im: "",
      email: "",
      telephone: "",
      cep: "",
      city: "",
      country: "",
      neighborhood: "",
      complement: "",
      address: "",
      address_number: "",
      uf_id: "",
      bank_id: "",
      agency: "",
      account: "",
      note: "",
      status: "",
      loading: false,
      loadingDelete: false,
      errors: [],
      errorsDelete: [],
      guarantor: "NAO",
      guarantor_name: "",
      guarantor_address: "",
      guarantor_address_number: "",
      guarantor_neighborhood: "",
      guarantor_complement: "",
      guarantor_cep: "",
      guarantor_city: "",
      guarantor_uf: "",
      guarantor_ie: "",
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    permission,

    inputCEP(value) {
      this.cep = value.cep;
      this.city = value.localidade || this.city;
      this.neighborhood = value.bairro || this.neighborhood;
      this.complement = value.complemento || this.complement;
      this.address = value.logradouro || this.address;

      const matched_uf = this.ufs.find(
        (item) => item.initials.toLowerCase() === value.uf.toLowerCase()
      );

      if (matched_uf) {
        this.uf_id = matched_uf.id;
      }
    },

    retrieve() {
      let { data } = this;

      this.resident_id = data.resident_id;

      if (data.resident_id) {
        let resident = this.all_residents.filter(
          ({ id }) => id == data.resident_id
        );
        if (resident.length > 0) {
          this.resident = resident;
        }
      }

      this.cpf_cnpj = data.cpf_cnpj;
      this.is_foreign = data.is_foreign == 1 ? true : false;
      this.name = data.name;
      this.fantasy_name = data.fantasy_name;
      this.ie = data.ie;
      this.im = data.im;
      this.email = data.email;
      this.telephone = data.telephone;
      this.cep = data.cep;
      this.city = data.city;
      this.country = data.country;
      this.neighborhood = data.neighborhood;
      this.complement = data.complement;
      this.address = data.address;
      this.address_number = data.address_number;
      this.uf_id = data.uf_id;
      this.bank_id = data.bank_id;
      this.agency = data.agency;
      this.account = data.account;
      this.note = data.note ? data.note : "";
      this.status = data.status;
      this.guarantor = data.guarantor;
      this.guarantor_name = data.guarantor_name;
      this.guarantor_address = data.guarantor_address;
      this.guarantor_address_number = data.guarantor_address_number;
      this.guarantor_neighborhood = data.guarantor_neighborhood;
      this.guarantor_complement = data.guarantor_complement;
      this.guarantor_cep = data.guarantor_cep;
      this.guarantor_city = data.guarantor_city;
      this.guarantor_uf = data.guarantor_uf;
      this.guarantor_ie = data.guarantor_ie;

      this.countries = countries;
    },

    async update() {
      try {
        this.loading = true;

        const {
          data,
          resident_id,
          cpf_cnpj,
          is_foreign,
          name,
          fantasy_name,
          ie,
          im,
          email,
          telephone,
          cep,
          city,
          country,
          neighborhood,
          complement,
          address,
          address_number,
          uf_id,
          bank_id,
          agency,
          account,
          note,
          status,
          guarantor,
          guarantor_name,
          guarantor_address,
          guarantor_address_number,
          guarantor_neighborhood,
          guarantor_complement,
          guarantor_cep,
          guarantor_city,
          guarantor_uf,
          guarantor_ie,
        } = this;

        let params = {
          id: data.id,
          resident_id,
          cpf_cnpj,
          is_foreign,
          name,
          fantasy_name,
          ie,
          im,
          email,
          telephone,
          cep,
          city,
          country,
          neighborhood,
          complement,
          address,
          address_number,
          uf_id,
          bank_id,
          agency,
          account,
          note,
          status,
          guarantor,
          guarantor_name,
          guarantor_address,
          guarantor_address_number,
          guarantor_neighborhood,
          guarantor_complement,
          guarantor_cep,
          guarantor_city,
          guarantor_uf,
          guarantor_ie,
        };

        const response = await api.put("/rest-home/financial/client", params);

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.$bvModal.hide(`edit-${data.id}`);
          this.$emit("success");
          this.errors = [];
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },

    async handleDelete() {
      try {
        this.loadingDelete = true;

        let {
          data: { id },
          transfer_id,
          type_delete,
        } = this;

        const data = { id, transfer_id, type_delete };

        const response = await api.delete("/rest-home/financial/client", {
          data,
        });

        const { error, errors, message } = response.data;

        if (error) {
          this.errorsDelete = errors;
        } else {
          this.errorsDelete = [];
          toast(message, "success");
          this.$bvModal.hide(`edit-${this.data.id}`);
          this.$emit("success");
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loadingDelete = false;
      }
    },

    deleteClient() {
      this.$bvModal.show(`delete-client-${this.data.id}`);
    },

    handleVerifyReleasesToDelete(total) {
      this.totalReleases = total;

      if (total == 0) {
        this.type_delete = "type_only_delete";
      } else {
        this.type_delete = null;
      }
    },
  },
};
</script>

<style scoped>
/* Main Container */
.edit-form-modern {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  min-height: 100vh;
  padding: 24px;
}

.edit-container {
  max-width: 1200px;
  margin: 0 auto;
  background: white;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

/* Delete Modal Styling */
.modern-modal >>> .modal-content {
  border: none !important;
  border-radius: 16px !important;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2) !important;
}

.modal-header-danger {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: white;
  padding: 24px 32px;
  border-radius: 16px 16px 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: none;
}

.modal-title-modern {
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  display: flex;
  align-items: center;
}

.close-btn-modern {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.close-btn-modern:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.1);
}

.delete-modal-content {
  padding: 32px;
}

.warning-section {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 24px;
  padding: 20px;
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  border: 1px solid #fca5a5;
  border-radius: 12px;
}

.warning-icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  flex-shrink: 0;
}

.warning-text h4 {
  color: #991b1b;
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 8px 0;
}

.warning-text p {
  color: #7f1d1d;
  margin: 0;
  font-size: 14px;
}

.releases-warning {
  margin-bottom: 24px;
}

.releases-info {
  background: linear-gradient(135deg, #fef3c7 0%, #fed7aa 100%);
  border: 1px solid #f59e0b;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  color: #92400e;
  font-weight: 500;
}

.options-section h5 {
  color: #1e293b;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 16px;
}

.radio-options {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;
}

.radio-option {
  display: flex;
  align-items: center;
}

.radio-input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.radio-label {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  margin: 0;
  padding: 12px;
  border-radius: 8px;
  transition: all 0.3s ease;
  width: 100%;
}

.radio-label:hover {
  background: #f8fafc;
}

.radio-indicator {
  width: 20px;
  height: 20px;
  border: 2px solid #e5e7eb;
  border-radius: 50%;
  position: relative;
  transition: all 0.3s ease;
  background: white;
  flex-shrink: 0;
}

.radio-input:checked + .radio-label .radio-indicator {
  border-color: #0f65b0;
}

.radio-input:checked + .radio-label .radio-indicator::after {
  content: "";
  position: absolute;
  width: 10px;
  height: 10px;
  background: #0f65b0;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.radio-text {
  font-size: 14px;
  color: #374151;
  font-weight: 500;
}

.transfer-section {
  margin-top: 16px;
  padding: 16px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}

.modal-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  padding-top: 24px;
  border-top: 1px solid #e5e7eb;
}

.cancel-btn {
  background: #f8fafc !important;
  color: #374151 !important;
  border: 2px solid #e5e7eb !important;
  border-radius: 8px !important;
  font-weight: 600 !important;
  padding: 12px 24px !important;
  transition: all 0.3s ease !important;
}

.cancel-btn:hover {
  background: #f1f5f9 !important;
  border-color: #cbd5e1 !important;
}

.delete-btn {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 8px !important;
  font-weight: 600 !important;
  padding: 12px 24px !important;
  box-shadow: 0 4px 15px rgba(239, 68, 68, 0.3) !important;
  transition: all 0.3s ease !important;
}

.delete-btn:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 6px 20px rgba(239, 68, 68, 0.4) !important;
}

/* Header Section */
.form-header {
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%);
  color: white;
  padding: 32px;
  text-align: center;
}

.form-title {
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 8px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.title-icon {
  color: white;
  margin-right: 12px;
  font-size: 24px;
}

.form-subtitle {
  color: rgba(255, 255, 255, 0.9);
  margin: 0;
  font-size: 16px;
}

/* Tabs Styling */
.tabs-container {
  background: #f8fafc;
  border-bottom: 1px solid #e5e7eb;
}

.modern-tabs {
  display: flex;
  padding: 0 32px;
}

.tab-button {
  background: transparent;
  border: none;
  padding: 16px 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  border-bottom: 3px solid transparent;
  transition: all 0.3s ease;
  color: #64748b;
  font-weight: 500;
}

.tab-button:hover {
  color: #0f65b0;
  background: rgba(15, 101, 176, 0.05);
}

.tab-button.active {
  color: #0f65b0;
  border-bottom-color: #0f65b0;
  background: white;
}

.tab-icon {
  font-size: 14px;
}

.tab-text {
  font-size: 14px;
}

/* Tab Content */
.tab-content-modern {
  background: white;
}

.tab-pane-modern {
  display: none;
  padding: 32px;
}

.tab-pane-modern.active {
  display: block;
}

/* Form Sections */
.form-section {
  margin-bottom: 24px;
}

.section-header {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e5e7eb;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
}

.section-title i {
  color: #0f65b0;
}

/* Form Grid */
.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  align-items: start;
  margin-bottom: 32px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

.form-group.checkbox-group {
  justify-content: center;
  align-items: flex-start;
}

/* Form Controls */
.form-label {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin: 0;
}

.form-control-modern {
  padding: 12px 16px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.3s ease;
  background: white;
}

.form-control-modern:focus {
  outline: none;
  border-color: #0f65b0;
  box-shadow: 0 0 0 3px rgba(15, 101, 176, 0.1);
}

.form-control-modern.disabled {
  background: #f9fafb;
  color: #6b7280;
  cursor: not-allowed;
}

.form-control-modern::placeholder {
  color: #9ca3af;
}

.help-text {
  font-size: 12px;
  color: #6b7280;
  font-style: italic;
  margin-top: 4px;
}

/* Custom Checkbox */
.custom-checkbox {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.checkbox-input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  margin: 0;
}

.checkbox-indicator {
  width: 20px;
  height: 20px;
  border: 2px solid #e5e7eb;
  border-radius: 4px;
  position: relative;
  transition: all 0.3s ease;
  background: white;
}

.checkbox-input:checked + .checkbox-label .checkbox-indicator {
  background: #0f65b0;
  border-color: #0f65b0;
}

.checkbox-input:checked + .checkbox-label .checkbox-indicator::after {
  content: "✓";
  position: absolute;
  color: white;
  font-size: 12px;
  font-weight: bold;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.checkbox-text {
  font-size: 14px;
  color: #374151;
  font-weight: 500;
}

/* Footer */
.form-footer {
  background: #f8fafc;
  border-top: 1px solid #e5e7eb;
  padding: 24px 32px;
}

.actions-section {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.delete-action-btn {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 14px 24px !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  box-shadow: 0 4px 15px rgba(239, 68, 68, 0.3) !important;
  transition: all 0.3s ease !important;
}

.delete-action-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(239, 68, 68, 0.4) !important;
}

.save-btn {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 14px 32px !important;
  font-weight: 600 !important;
  font-size: 16px !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  box-shadow: 0 4px 15px rgba(16, 185, 129, 0.3) !important;
  transition: all 0.3s ease !important;
  min-width: 180px !important;
}

.save-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4) !important;
}

.save-btn:disabled,
.delete-action-btn:disabled {
  opacity: 0.7 !important;
  transform: none !important;
}

/* Responsive Design */
@media (max-width: 768px) {
  .edit-form-modern {
    padding: 16px;
  }

  .form-header {
    padding: 24px 20px;
  }

  .form-title {
    font-size: 24px;
    flex-direction: column;
    gap: 8px;
  }

  .modern-tabs {
    padding: 0 16px;
  }

  .tab-button {
    padding: 12px 16px;
    font-size: 13px;
  }

  .tab-pane-modern {
    padding: 24px 16px;
  }

  .form-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .form-footer {
    padding: 20px 16px;
  }

  .actions-section {
    flex-direction: column;
  }

  .save-btn,
  .delete-action-btn {
    width: 100% !important;
    padding: 16px !important;
  }

  .delete-modal-content {
    padding: 24px;
  }

  .modal-actions {
    flex-direction: column;
  }

  .cancel-btn,
  .delete-btn {
    width: 100% !important;
  }
}
</style>